export default __webpack_public_path__ + "static/media/chevronBoldWhite.20a743a7.svg";